import type { SVGProps } from 'react';

const SvgBrowsing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="browsing">
      <path d="M3 31.71h26A2.75 2.75 0 0 0 31.77 29V9A2.75 2.75 0 0 0 29 6.29h-3.92v1.5H29A1.25 1.25 0 0 1 30.27 9v20A1.25 1.25 0 0 1 29 30.21H3A1.25 1.25 0 0 1 1.73 29V9A1.25 1.25 0 0 1 3 7.79h2.56v-1.5H3A2.75 2.75 0 0 0 .23 9v20A2.75 2.75 0 0 0 3 31.71" />
      <path d="M23.32 10.3a8.54 8.54 0 1 0-4.26 5.84l5 7.27 1.24-.84-5-7.26a8.4 8.4 0 0 0 3.02-5.01m-9.59 5.27a6.94 6.94 0 0 1-5.55-8.11A7 7 0 0 1 15 1.79a7 7 0 0 1 1.29.12 6.91 6.91 0 0 1 5.29 4.61H10.46V8h11.47a7.2 7.2 0 0 1-.09 2 6.95 6.95 0 0 1-8.11 5.54ZM5.96 20.4H14v1.5H5.96zM5.96 25.56h5.14v1.5H5.96z" />
    </g>
  </svg>
);

export default SvgBrowsing;
